import moment from 'moment'

export const tableColums= [
  {
    title: '订单号',
    dataIndex: 'odrNo',
    scopedSlots: { customRender: 'odrNo' },
    fixed: 'left',
    width: 230
  },
  {
    title: '订单状态',
    dataIndex: 'statusText',
    scopedSlots: { customRender: 'statusText' },
    width: 200,
  },
  {
    title: '货品信息',
    dataIndex: 'goosInfo',
    scopedSlots: { customRender: 'goosInfo' },
    width: 170
  },
  {
    title: '发货地信息',
    dataIndex: 'startAddress',
    scopedSlots: { customRender: 'startAddress' },
    width: 240
  },
  {
    title: '收货地信息',
    dataIndex: 'endAddress',
    scopedSlots: { customRender: 'endAddress' },
    width: 240
  },
  {
    title: '订单总金额(元)',
    dataIndex: 'orderAmount',
    scopedSlots: { customRender: 'orderAmount' },
    width: 150
  },
  {
    title: '派车信息',
    dataIndex: 'dispatchInfo',
    scopedSlots: { customRender: 'dispatchInfo' },
    width: 200
  },
  {
    title: '服务商',
    dataIndex: 'carrierTenantName',
    scopedSlots: { customRender: 'carrierTenantName' },
    customRender: (text, record) => record.ext?.demoData ? '运荔枝演示' : text, 
    width: 200
  },
  {
    title: '子母单标识',
    dataIndex: 'bdstNumber',
    scopedSlots: { customRender: 'bdstNumber' },
    customRender: (text) => text||'--', 
    width: 200
  },
  {
    title: '下单信息',
    dataIndex: 'createTime',
    scopedSlots: { customRender: 'createTime' },
    width: 200
  },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right',
    scopedSlots: { customRender: 'action' },
    width: 200
  },
];



export const SearchFiled= [
  {
  label:'订单号',
  name:'unifyNo',
  type:'input',
  prop:{
    placeholder: '请输入订单号',
  }
},
{
  label:'外部订单号',
  name:'crmNumber',
  type:'input',
  prop:{
    placeholder: '请输入外部订单号',
    maxLength:100
  },
},
{
  label:'订单状态',
  name:'orderType',
  custom:true
},
{
  label:'下单日期',
  name:'createTime__BETWEEN',
  type:'date',
  prop:{
    showTime:{
      format: "HH:mm:ss",
      defaultValue: [moment().subtract(30, 'days').startOf('day'), moment().endOf('day')],
      },
    allowClear:true,
    format:"YYYY-MM-DD HH:mm:ss",
    placeholder: ['开始日期', '结束日期'],
    maxLength:100,
  },
},
{
  label:'货品信息',
  name:'goodsProperty__IN',
  type:'input',
  prop:{
    placeholder: '请输入货品名称/品类名称关键字',
    maxLength:100
  },
},
{
  label:'发货地',
  name:'startAddrs',
  type:'input',
  prop:{
    placeholder: '请输入发货地名称/地址',
    maxLength:100
  },
},
{
  label:'收货地',
  name:'endAddrs',
  type:'input',
  prop:{
    placeholder: '请输入收货地名称/地址',
    maxLength:100
  },
},
{
  label:'下单人',
  name:'createUserName',
  type:'input',
  prop:{
    placeholder: '请选择下单人',
    maxLength:100
  },
},
{
  label:'服务商',
  name:'serviceProvider',
  custom:true
},
{
  label:'项目',
  name:'projectId',
  custom:true
},
{
  label:'子母单标识',
  name:'bdstNumber',
  type:'input',
  prop:{
    placeholder: '请输入子母单标识',
    maxLength:20,
    allowClear:true
  },
}
]